import { TypeDefinition } from "../generic";

export class DisclosureStatuses {
    public static HasDisclosure: TypeDefinition = { id: 1, name: "With disclosure" };
    public static HasNoDisclosure: TypeDefinition = { id: 2, name: "Without disclosure" };
    public static IsCOI: TypeDefinition = { id: 3, name: "Conflict of interest (COI)" };

    public static Values: TypeDefinition[] = [
        DisclosureStatuses.HasDisclosure,
        DisclosureStatuses.HasNoDisclosure,
        DisclosureStatuses.IsCOI,
    ];
}



// WEBPACK FOOTER //
// ./src/models/financialDisclosure/DisclosureStatuses.ts